// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34634a27","488":"f4e14f69","732":"0e6f6a83","977":"72abd170"}[chunkId] + ".chunk.js";
};